// ref. https://github.com/jonschlinkert/isobject/blob/master/index.js
// 上記のコードを修正。 Array or Object を判定したいので、まとめてメソッドとして実装。

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isArrayOrObject(val: any) {
  return Array.isArray(val) || (val != null && typeof val === "object");
}
